<template>
    <div>
        <div class="row">
            <div class="col-lg-4">
                <CustomerSelect
                    v-model="filters.selectedCustomer"
                />
            </div>
            <div class="col-lg-8">
                <label>
                    <strong>
                        Quote Status
                    </strong>
                </label>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-awaiting-price">
                                <input v-model="filters.status" class="me-1" id="checkbox-awaiting-price" type="checkbox" name="status[]" value="awaiting price">
                                Awaiting Price
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-priced">
                                <input v-model="filters.status" class="me-1" id="checkbox-priced" type="checkbox" name="status[]" value="priced">
                                Priced
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-booked">
                                <input v-model="filters.status" class="me-1" id="checkbox-booked" type="checkbox" name="status[]" value="booked">
                                Booked
                            </label>
                        </div>
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-declined">
                                <input v-model="filters.status" class="me-1" id="checkbox-declined" type="checkbox" name="status[]" value="declined">
                                Declined
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="checkbox checkbox-primary">
                            <label for="checkbox-cancelled">
                                <input v-model="filters.status" class="me-1" id="checkbox-cancelled" type="checkbox" name="status[]" value="cancelled">
                                Cancelled
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <table ref="quotesTable" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
                <thead>
                    <tr>
                        <th>Customer</th>
                        <th>User</th>
                        <th>Vehicle Type</th>
                        <th>Reference</th>
                        <th>Status</th>
                        <th>Collection</th>
                        <th>Delivery</th>
                        <th>Price</th>
                        <th>Created</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import { buildColumns } from "@/helpers/build-columns";
import CustomerSelect from '@/components/movements/components/CustomerSelect.vue';

const props = defineProps({
    ajaxUrl: {
        type: String,
        required: true,
    },
    orderBy: {
        type: Array,
        default: () => [[8, 'desc']]
    },
});

const columnDefinitions = reactive({
    customer: {
        name: 'customer.name',
        render: function (data, type, row) {
            return row.computed_customer;
        }
    },
    user: {
        data: 'user.name',
        defaultContent: '',
    },
    vehicle_type: {
        data: 'vehicle_type.type',
        defaultContent: '',
        searchable: false,
    },
    reference: {
        data: 'id',
        searchable: false,
        render: function (data, type, row) {
            return row.computed_reference;
        }
    },
    status: {
        data: 'status',
        searchable: false,
    },
    collection: {
        data: 'collection_date',
        searchable: false,
        render: function (data, type, row) {
            return row.computed_collection_date;
        }
    },
    delivery: {
        data: 'delivery_date',
        searchable: false,
        render: function (data, type, row) {
            return row.computed_delivery_date;
        }
    },
    price: {
        data: 'quote_price',
        searchable: false,
        render: function (data) {
            return data ? `£${Number(data).toFixed(2)}` : '';
        }
    },
    created: {
        data: 'created_at',
        searchable: false,
        render: function (data, type, row) {
            return row.computed_created_at;
        }
    },
    actions: {
        name: 'actions',
        data: 'actions',
        searchable: false,
        orderable: false,
        width: '160px',
    }
});

const filters = reactive({
    selectedCustomer: null,
    status: [
        'awaiting price',
        'priced',
        'booked',
        'declined',
        'cancelled',
    ],
});

const quotesTable = ref(null);

onMounted(() => {
    const table = window.jQuery(quotesTable.value).on('preXhr.dt', (e, settings, data) => {
        data.filters = filters;
    }).DataTable({
        dom: 'rtip', // remove 'f' to hide search
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ajax: {
            url: props.ajaxUrl,
        },
        order: props.orderBy,
        columns: buildColumns(columnDefinitions, []),
    });

    watch(
        filters,
        () => table.ajax.reload(null, false),
        {
            deep: true
        }
    );
});
</script>
